// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSettingUtil')
class Toolbox__GoalSettingUtil {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "none" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSettingUtil' {
        return 'Toolbox.GoalSettingUtil'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSettingUtil' {
        return 'Toolbox.GoalSettingUtil'
    }

    static get __baseType(): 'Toolbox.GoalSettingUtil' {
        return 'Toolbox.GoalSettingUtil'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSettingUtil' {
        return 'Toolbox.GoalSettingUtil'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSettingUtil[BoInfoSymbol]
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSettingUtil>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSettingUtil()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSettingUtil>, restrictToClass?: Class<Partial<Toolbox__GoalSettingUtil>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSettingUtil.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []

        names.push('createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static async getAllUsers(): Promise<Sys.Types.UserRecord[]> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<Sys.Types.UserRecord[]>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'getAllUsers', args)
        return result
    }

    static async getMyGoalSettingsList(): Promise<{ list: This.GoalSetting[], newest: This.GoalSetting }> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<{ list: This.GoalSetting[], newest: This.GoalSetting }>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'getMyGoalSettingsList', args)
        return result
    }

    static async getMyAndTeamsOpenGoalSettings(): Promise<{ mine: This.GoalSetting.ForList[], team: This.GoalSetting.ForList[] }> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<{ mine: This.GoalSetting.ForList[], team: This.GoalSetting.ForList[] }>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'getMyAndTeamsOpenGoalSettings', args)
        return result
    }

    static async loadById(id: This.GoalSetting.Id, viewModeId: This.GoalSettingViewMode.Id): Promise<{ gs: This.GoalSetting, viewModeId: This.GoalSettingViewMode.Id }> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<{ gs: This.GoalSetting, viewModeId: This.GoalSettingViewMode.Id }>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'loadById', args)
        return result
    }

    static async listForAllUsers(cycleId: This.GoalSettingCycle.Id): Promise<This.GoalSettingAndUser[]> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<This.GoalSettingAndUser[]>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'listForAllUsers', args)
        return result
    }

    static async startGoalSetting(employeeId: string | undefined, cycleId: This.GoalSettingCycle.Id, statusId: This.GoalSettingStatus.Id): Promise<This.GoalSetting.ForList[]> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<This.GoalSetting.ForList[]>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'startGoalSetting', args)
        return result
    }

    static confetti(): void {
        var count = 500;
        var defaults = {
            origin: { y: 1 }
        };

        function fire(particleRatio, opts) {
            Sys.Confetti({
                ...defaults,
                ...opts,
                particleCount: Math.floor(count * particleRatio)
            });
        }

        fire(0.25, {
            spread: 26,
            startVelocity: 75,
        });
        fire(0.2, {
            spread: 60,
        });
        fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8
        });
        fire(0.1, {
            spread: 120,
            startVelocity: 50,
            decay: 0.92,
            scalar: 1.2
        });
        fire(0.1, {
            spread: 120,
            startVelocity: 45,
        });
    }

    static async moveToSelfReview(goalSettingId: This.GoalSetting.Id | undefined, cycleId: This.GoalSettingCycle.Id | undefined): Promise<number> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<number>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'moveToSelfReview', args)
        return result
    }

    static async updateLineManager(employeeUserId: string, managerUserId: string): Promise<Sys.Types.UserRecord> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<Sys.Types.UserRecord>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'updateLineManager', args)
        return result
    }

    static async updateGsManager(gsId: This.GoalSetting.Id, managerUserId: string): Promise<Sys.Types.UserRecord> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<Sys.Types.UserRecord>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'updateGsManager', args)
        return result
    }

    static async deleteById(id: This.GoalSetting.Id): Promise<void> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<void>('Entity', 'Toolbox', 'GoalSettingUtil', undefined, 'deleteById', args)
        return result
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSettingUtil {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSettingUtil { }

export import GoalSettingUtil = Toolbox__GoalSettingUtil
setTimeout(() => {
    jsonProperty(() => Date)(Toolbox__GoalSettingUtil.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingUtil.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingUtil.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingUtil.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingUtil.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingUtil.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSettingUtil.prototype, 'versionNumber')
})
